var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.475 11.525H19.9q-.175-3.025-2.287-5.15Q15.5 4.25 12.475 4.1ZM11.55 19.9V4.1q-3.15.15-5.312 2.437Q4.075 8.825 4.075 12q0 3.175 2.163 5.462Q8.4 19.75 11.55 19.9Zm.925 0q3-.15 5.125-2.287 2.125-2.138 2.3-5.163h-7.425ZM12 12Zm0 8.85q-1.825 0-3.438-.7-1.612-.7-2.812-1.888-1.2-1.187-1.9-2.8-.7-1.612-.7-3.462 0-1.825.7-3.438.7-1.612 1.888-2.812 1.187-1.2 2.8-1.9 1.612-.7 3.462-.7 1.825 0 3.438.7 1.612.7 2.812 1.9 1.2 1.2 1.9 2.812.7 1.613.7 3.438 0 1.825-.7 3.438-.7 1.612-1.887 2.825-1.188 1.212-2.8 1.9-1.613.687-3.463.687Z"
  })));
};

export { SvgAnalytics as ReactComponent };
export default __webpack_public_path__ + "analytics.svg";